import React from 'react';
import Rocket from './rockets/Rocket';

const Home = () => (
  <>
    <Rocket />
  </>
);

export default Home;
